export const studentsActionTypes = {
  GET_STUDENTS_SUCCESS: 'GET_STUDENTS_SUCCESS',
}
